<template>
    <div>
        <app-layout>
            <template v-slot:header>
                <Header :title="$t('bulk_import')" :isFilter="false"/>
            </template>
            <template v-slot:header-mobile>
                <HeaderMobile :title="$t('bulk_import')" :isFilter="false"/>
            </template>
            <h6>{{ $t('process_select') }}</h6>
            <div class="border rounded p-5 mb-3">
                <multiselect
                    :clear-on-select="true"
                    :close-on-select="true"
                    :deselect-label="''"
                    :options="computeReportTypes"
                    :placeholder="$t('select')"
                    :select-label="''"
                    :selected-label="''"
                    label="text"
                    track-by="value"
                    v-model="reportType"
                />
            </div>
            <b-row>
                <div class="col-12" v-if="reportType">
                    <h6>
                    <span v-if="reportType && reportType.text">
                        {{ reportType.text }}
                    </span>
                    </h6>
                    <b-row>
                        <b-col cols="12">
                            <div class="border rounded p-5">
                                <component v-if="reportType && reportType.value" :is="reportType.value"/>
                            </div>
                        </b-col>
                    </b-row>
                </div>
            </b-row>
        </app-layout>
    </div>
</template>

<script>
// Template
import AppLayout from '@/layouts/AppLayout'
import Header from '@/layouts/AppLayout/Header'
import HeaderMobile from '@/layouts/AppLayout/HeaderMobile'
// Data
import ReportTypes from '../data/ReportTypes'
// Pages
import makeUpExam from '@/modules/bulkImport/pages/makeUpExam/Index'
import studentCourse from '@/modules/bulkImport/pages/studentCourse/Index'
import studentCourseDelete from '@/modules/bulkImport/pages/studentCourseDelete/Index'
import studentSemesterStatusUpdate from '@/modules/bulkImport/pages/studentSemesterStatusUpdate/Index'
import bulkStudentSlotUpdate from '@/modules/bulkImport/pages/bulkStudentSlotUpdate/Index'
import bulkStudentAddPermit from '@/modules/bulkImport/pages/bulkStudentAddPermit/Index'
import bulkStudentSemesterUpdate from '@/modules/bulkImport/pages/bulkStudentSemesterUpdate/Index'
import bulkDeletePermit from '@/modules/bulkImport/pages/bulkDeletePermit/Index'
import bulkCourseNameImport from '@/modules/bulkImport/pages/bulkCourseNameImport/Index'
import coursesNameImport from '@/modules/bulkImport/pages/coursesNameImport/Index'
import studentProgramTransfer from '../pages/studentProgramTransfer/Index'
import rectorOrderExcelImport from '../pages/rectorOrderExcelImport/Index'
import pilotageInvoiceImport from '@/modules/bulkImport/pages/pilotageInvoiceImport/Index'
import thesisAndProjectsImport from '@/modules/bulkImport/pages/thesisAndProjectsImport/Index'
import paymentApprovalExceptionsImport from '@/modules/bulkImport/pages/paymentApprovalExceptionsImport/Index'
import bulkContactInformationUpdate from '@/modules/bulkImport/pages/bulkContactInformationUpdate/Index'
import bulkGradingSystemUpdate from '@/modules/bulkImport/pages/bulkGradingSystemUpdate/Index'
import updatingCreditsAndEcts from '@/modules/bulkImport/pages/updatingCreditsAndEcts/Index'
import personDataImport from '@/modules/bulkImport/pages/personDataImport/Index'
import updateStaffExpirationDate from '@/modules/bulkImport/pages/updateStaffExpirationDate/Index'

export default {
    components: {
        AppLayout,
        Header,
        HeaderMobile,
        makeUpExam,
        studentCourse,
        studentCourseDelete,
        studentSemesterStatusUpdate,
        bulkStudentSlotUpdate,
        bulkStudentAddPermit,
        bulkStudentSemesterUpdate,
        bulkCourseNameImport,
        bulkDeletePermit,
        coursesNameImport,
        studentProgramTransfer,
        rectorOrderExcelImport,
        pilotageInvoiceImport,
        thesisAndProjectsImport,
        paymentApprovalExceptionsImport,
        bulkContactInformationUpdate,
        bulkGradingSystemUpdate,
        updatingCreditsAndEcts,
        personDataImport,
        updateStaffExpirationDate

    },
    metaInfo() {
        return {
            title: this.$t('bulk_import')
        }
    },
    data() {
        return {
            reportType: null
        }
    },
    computed: {
        computeReportTypes() {
            return ReportTypes().filter((item) => {
                return this.checkPermission(item.permission)
            })
        }
    }
}
</script>
